angular
  .module('common.directives')
  .directive('organizationManage', function () {
    return {
      scope: {
        organizationId: '='
      },
      templateUrl: './templates/organizationManage.view.html?t=' + webpackHash,
      controller: 'manageOrganizationCtrl',
      link: function ($scope, $element) {}
    }
  })
